/**
 * Manage the how Access User Login data and Auth Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage
**/

const TOKEN_KEY = 'token';
const LOCALE_KEY = 'locale';
const USER_IP = 'userip';
export const StorageService = {
    setLocale(locale) {
        localStorage.setItem(LOCALE_KEY, locale);
    },
    getLocale() {
        return localStorage.getItem(LOCALE_KEY);
    },
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },
    saveLoginData(loginData) {
        let token = loginData.token;
        localStorage.setItem(TOKEN_KEY, token);
    },
    removeLoginData() {
        localStorage.removeItem(TOKEN_KEY);

        //remove language locale
        localStorage.removeItem(LOCALE_KEY);
    },
}